// import React, { Fragment, useEffect, useRef, useState } from "react";
// import bigTripsImg from "../assets/media/bigTrips.jpg";
// import weekendTripImg from "../assets/media/weekendTrips.jpg";
// import NotFound from "../assets/media/page_not-found.jpg";
// import WeekendTripsAPI from "../api/WeekendTripsAPI";
// import BigTripsAPI from "../api/BigTripsAPI";
// import TripCard from "../components/TripCard";

// const WeekendTrips = () => {
//   const [weekendTrips, setWeekendTrips] = useState([]);
//   const [bigTrips, setBigTrips] = useState([]);
//   const [displayedTrips, setDisplayedTrips] = useState([]);
//   const [filteredTrips, setFilteredTrips] = useState([]);
//   const [selectedState, setSelectedState] = useState("");
//   const [availableStates, setAvailableStates] = useState([]);
//   const [loading, setLoading] = useState({
//     weekend: true,
//     big: true,
//   });
//   const [error, setError] = useState(null);
//   const sectionRefs = useRef({});
//   const [activeBtn, setActiveBtn] = useState("Weekend-Trips");

//   // ✅ sort safely
//   const sortTripsAlphabetically = (trips) => {
//     if (!Array.isArray(trips)) return [];
//     return [...trips].sort((a, b) =>
//       (a?.title || "").localeCompare(b?.title || "")
//     );
//   };

//   // ✅ get unique states safely
//   const getUniqueStates = (trips) => {
//     if (!Array.isArray(trips)) return [];
//     const states = [...new Set(trips.map((trip) => trip?.location).filter(Boolean))];
//     return states.sort();
//   };

//   useEffect(() => {
//     const fetchWeekendTrips = async () => {
//       try {
//         const res = await WeekendTripsAPI.getweekendTrips();
//         const sortedTrips = sortTripsAlphabetically(res?.data);
//         setWeekendTrips(sortedTrips);
//         setLoading((prev) => ({ ...prev, weekend: false }));

//         if (activeBtn === "Weekend-Trips") {
//           setDisplayedTrips(sortedTrips);
//           setFilteredTrips(sortedTrips);
//           setAvailableStates(getUniqueStates(sortedTrips));
//         }
//       } catch (err) {
//         console.error("Error fetching weekend trips:", err);
//         setError("Unable to load weekend trip data.");
//         setLoading((prev) => ({ ...prev, weekend: false }));
//       }
//     };

//     const fetchBigTrips = async () => {
//       try {
//         const res = await BigTripsAPI.getBigTrips();
//         const sortedTrips = sortTripsAlphabetically(res?.data);
//         setBigTrips(sortedTrips);
//         setLoading((prev) => ({ ...prev, big: false }));

//         if (activeBtn === "Big-Trips") {
//           setDisplayedTrips(sortedTrips);
//           setFilteredTrips(sortedTrips);
//           setAvailableStates(getUniqueStates(sortedTrips));
//         }
//       } catch (err) {
//         console.error("Error fetching big trips:", err);
//         setError("Unable to load big trip data.");
//         setLoading((prev) => ({ ...prev, big: false }));
//       }
//     };

//     fetchWeekendTrips();
//     fetchBigTrips();
//   }, []);

//   const handleButtonClick = (type) => {
//     setActiveBtn(type);
//     setSelectedState("");

//     if (type === "Weekend-Trips") {
//       setDisplayedTrips(weekendTrips);
//       setFilteredTrips(weekendTrips);
//       setAvailableStates(getUniqueStates(weekendTrips));
//     } else {
//       setDisplayedTrips(bigTrips);
//       setFilteredTrips(bigTrips);
//       setAvailableStates(getUniqueStates(bigTrips));
//     }
//   };

//   const handleStateFilter = (state) => {
//     setSelectedState(state);

//     if (state === "") {
//       setFilteredTrips(displayedTrips);
//     } else {
//       const filtered = displayedTrips.filter(
//         (trip) => trip?.location === state
//       );
//       setFilteredTrips(filtered);

//       setTimeout(() => {
//         const sectionElement = sectionRefs.current[state];
//         if (sectionElement) {
//           const yOffset = -100; // 👈 adjust this value to match your header height
//           const y =
//             sectionElement.getBoundingClientRect().top +
//             window.pageYOffset +
//             yOffset;

//           window.scrollTo({ top: y, behavior: "smooth" });
//         }
//       }, 100);

//     }
//   };

//   const groupTripsByLocation = (trips) => {
//     if (!Array.isArray(trips)) return [];

//     const grouped = {};
//     trips.forEach((trip) => {
//       const loc = trip?.location || "Unknown";
//       if (!grouped[loc]) grouped[loc] = [];
//       grouped[loc].push(trip);
//     });

//     return Object.entries(grouped)
//       .sort(([a], [b]) => a.localeCompare(b))
//       .map(([location, packages]) => ({
//         location,
//         packages: sortTripsAlphabetically(packages),
//       }));
//   };

//   if (
//     (activeBtn === "Weekend-Trips" && loading.weekend) ||
//     (activeBtn === "Big-Trips" && loading.big)
//   ) {
//     return (
//       <section className="custom-weekend-trips-section container-fluid">
//         <div className="row pb-3">
//           <div className="text-center py-5">
//             <h4>Loading {activeBtn}...</h4>
//           </div>
//         </div>
//       </section>
//     );
//   }

//   const groupedTrips = groupTripsByLocation(filteredTrips);

//   return (
//     <section className="custom-weekend-trips-section container-fluid">
//       <div className="row pb-3">
//         {/* Banner */}
//         <div className="custom-weekend-trips-img-banner position-relative p-0 col-xl-12">
//           <h1 className="fw-bold">{activeBtn}</h1>
//           <img
//             src={activeBtn === "Weekend-Trips" ? weekendTripImg : bigTripsImg}
//             alt="trips banner"
//           />
//         </div>

//         {/* Switch buttons */}
//         <div className="col-xl-6 px-3 py-2 custom-weekend-trips-btn1">
//           <button
//             className={`w-100 ${activeBtn === "Weekend-Trips" ? "btn-active" : "btn-inactive"
//               }`}
//             onClick={() => handleButtonClick("Weekend-Trips")}
//           >
//             Weekend Trips
//           </button>
//         </div>

//         <div className="col-xl-6 px-3 py-2 custom-weekend-trips-btn2">
//           <button
//             className={`w-100 ${activeBtn === "Big-Trips" ? "btn-active" : "btn-inactive"
//               }`}
//             onClick={() => handleButtonClick("Big-Trips")}
//           >
//             Big Trips
//           </button>
//         </div>

//         {/* Title */}
//         <div className="custom-fixed-departure-section-trips-heading">
//           <h3
//             className="pt-4 pb-2 mb-0 text-center"
//             style={{ color: "#249acd" }}
//           >
//             {activeBtn}
//           </h3>
//         </div>

//         {/* Filter Dropdown */}
//         <div className="col-lg-12 px-5 py-3">
//           <div className="row justify-content-end">
//             <div className="col-lg-2 col-md-8 col-sm-10 text-end">
//               <select
//                 onChange={(e) => handleStateFilter(e.target.value)}
//                 value={selectedState}
//                 className="pe-3 py-1"
//                 style={{ width: "150px" }}
//               >
//                 <option value="">All States</option>
//                 {availableStates.map((state, index) => (
//                   <Fragment key={index}>
//                     <option value={state}>{state}</option>
//                   </Fragment>
//                 ))}
//               </select>
//             </div>
//           </div>
//         </div>

//         {/* Trips Section */}
//         <div className="col-lg-12">
//           <div className="row d-flex justify-content-center">
//             <div className="col-lg-12 px-5">
//               {error ? (
//                 <div className="text-center py-5">
//                   <h4>{error}</h4>
//                   <img
//                     src={NotFound}
//                     alt="No Data"
//                     style={{ maxWidth: "400px", width: "100%" }}
//                   />
//                 </div>
//               ) : groupedTrips.length > 0 ? (
//                 groupedTrips.map((elem, index) => {
//                   const { location, packages } = elem;
//                   return (
//                     <div
//                       key={index}
//                       ref={(el) => (sectionRefs.current[location] = el)}
//                     >
//                       <h3
//                         className="pt-3 custom-font-size w-100"
//                         style={{
//                           color: "#249acd",
//                           padding: "0 0 7px",
//                           borderBottom: "4px solid #f36d21",
//                           textTransform: "capitalize",
//                         }}
//                       >
//                         {location}
//                       </h3>

//                       <div className="row custom-weekend-trips-row">
//                         {packages?.map((trip) => (
//                           <TripCard
//                             key={trip?.id || Math.random()}
//                             trip={trip}
//                             showLocationInCard={false}
//                           />
//                         ))}
//                       </div>
//                     </div>
//                   );
//                 })
//               ) : (
//                 <div className="text-center py-5">
//                   <img
//                     src={NotFound}
//                     alt="No Trips Available"
//                     style={{ maxWidth: "400px", width: "100%" }}
//                   />
//                   <h4 className="mt-3">
//                     {selectedState
//                       ? `No ${activeBtn} available for ${selectedState} at the moment.`
//                       : `No ${activeBtn} available at the moment.`}
//                   </h4>
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default WeekendTrips;


import React, { Fragment, useEffect, useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import bigTripsImg from "../assets/media/bigTrips.jpg";
import weekendTripImg from "../assets/media/weekendTrips.jpg";
import NotFound from "../assets/media/page_not-found.jpg";
import WeekendTripsAPI from "../api/WeekendTripsAPI";
import BigTripsAPI from "../api/BigTripsAPI";
import TripCard from "../components/TripCard";

const WeekendTrips = () => {
  const [weekendTrips, setWeekendTrips] = useState([]);
  const [bigTrips, setBigTrips] = useState([]);
  const [displayedTrips, setDisplayedTrips] = useState([]);
  const [filteredTrips, setFilteredTrips] = useState([]);
  const [selectedState, setSelectedState] = useState("");
  const [availableStates, setAvailableStates] = useState([]);
  const [loading, setLoading] = useState({ weekend: true, big: true });
  const [error, setError] = useState(null);
  const sectionRefs = useRef({});
  const [activeBtn, setActiveBtn] = useState("Weekend-Trips");

  // Sort alphabetically
  const sortTripsAlphabetically = (trips) => {
    if (!Array.isArray(trips)) return [];
    return [...trips].sort((a, b) =>
      (a?.title || "").localeCompare(b?.title || "")
    );
  };

  // Unique states list
  const getUniqueStates = (trips) => {
    if (!Array.isArray(trips)) return [];
    const states = [...new Set(trips.map((trip) => trip?.location).filter(Boolean))];
    return states.sort();
  };

  useEffect(() => {
    const fetchWeekendTrips = async () => {
      try {
        const res = await WeekendTripsAPI.getweekendTrips();
        const sortedTrips = sortTripsAlphabetically(res?.data);
        setWeekendTrips(sortedTrips);
        setLoading((prev) => ({ ...prev, weekend: false }));

        if (activeBtn === "Weekend-Trips") {
          setDisplayedTrips(sortedTrips);
          setFilteredTrips(sortedTrips);
          setAvailableStates(getUniqueStates(sortedTrips));
        }
      } catch (err) {
        console.error("Error fetching weekend trips:", err);
        setError("Unable to load weekend trip data.");
        setLoading((prev) => ({ ...prev, weekend: false }));
      }
    };

    const fetchBigTrips = async () => {
      try {
        const res = await BigTripsAPI.getBigTrips();
        const sortedTrips = sortTripsAlphabetically(res?.data);
        setBigTrips(sortedTrips);
        setLoading((prev) => ({ ...prev, big: false }));

        if (activeBtn === "Big-Trips") {
          setDisplayedTrips(sortedTrips);
          setFilteredTrips(sortedTrips);
          setAvailableStates(getUniqueStates(sortedTrips));
        }
      } catch (err) {
        console.error("Error fetching big trips:", err);
        setError("Unable to load big trip data.");
        setLoading((prev) => ({ ...prev, big: false }));
      }
    };

    fetchWeekendTrips();
    fetchBigTrips();
  }, []);

  const handleButtonClick = (type) => {
    setActiveBtn(type);
    setSelectedState("");

    if (type === "Weekend-Trips") {
      setDisplayedTrips(weekendTrips);
      setFilteredTrips(weekendTrips);
      setAvailableStates(getUniqueStates(weekendTrips));
    } else {
      setDisplayedTrips(bigTrips);
      setFilteredTrips(bigTrips);
      setAvailableStates(getUniqueStates(bigTrips));
    }
  };

  const handleStateFilter = (state) => {
    setSelectedState(state);

    if (state === "") {
      setFilteredTrips(displayedTrips);
    } else {
      const filtered = displayedTrips.filter((trip) => trip?.location === state);
      setFilteredTrips(filtered);

      setTimeout(() => {
        const sectionElement = sectionRefs.current[state];
        if (sectionElement) {
          const yOffset = -100;
          const y =
            sectionElement.getBoundingClientRect().top +
            window.pageYOffset +
            yOffset;
          window.scrollTo({ top: y, behavior: "smooth" });
        }
      }, 100);
    }
  };

  const groupTripsByLocation = (trips) => {
    if (!Array.isArray(trips)) return [];

    const grouped = {};
    trips.forEach((trip) => {
      const loc = trip?.location || "Unknown";
      if (!grouped[loc]) grouped[loc] = [];
      grouped[loc].push(trip);
    });

    return Object.entries(grouped)
      .sort(([a], [b]) => a.localeCompare(b))
      .map(([location, packages]) => ({
        location,
        packages: sortTripsAlphabetically(packages),
      }));
  };

  if (
    (activeBtn === "Weekend-Trips" && loading.weekend) ||
    (activeBtn === "Big-Trips" && loading.big)
  ) {
    return (
      <section className="custom-weekend-trips-section container-fluid">
        <div className="text-center py-5">
          <h4>Loading {activeBtn}...</h4>
        </div>
      </section>
    );
  }

  const groupedTrips = groupTripsByLocation(filteredTrips);

  return (
    <section className="custom-weekend-trips-section container-fluid">
      <div className="row pb-3">
        {/* Banner */}
        <div className="custom-weekend-trips-img-banner position-relative p-0 col-xl-12">
          <h1 className="fw-bold">{activeBtn}</h1>
          <img
            src={activeBtn === "Weekend-Trips" ? weekendTripImg : bigTripsImg}
            alt="trips banner"
          />
        </div>

        {/* Switch Buttons */}
        <div className="col-xl-6 px-3 py-2">
          <button
            className={`w-100 ${activeBtn === "Weekend-Trips" ? "btn-active" : "btn-inactive"}`}
            onClick={() => handleButtonClick("Weekend-Trips")}
          >
            Weekend Trips
          </button>
        </div>

        <div className="col-xl-6 px-3 py-2">
          <button
            className={`w-100 ${activeBtn === "Big-Trips" ? "btn-active" : "btn-inactive"}`}
            onClick={() => handleButtonClick("Big-Trips")}
          >
            Big Trips
          </button>
        </div>

        {/* Title */}
        <div className="custom-fixed-departure-section-trips-heading">
          <h3 className="pt-4 pb-2 mb-0 text-center" style={{ color: "#249acd" }}>
            {activeBtn}
          </h3>
        </div>

        {/* Filter Dropdown */}
        <div className="col-lg-12 px-5 py-3">
          <div className="row justify-content-end">
            <div className="col-lg-2 col-md-8 col-sm-10 text-end">
              <select
                onChange={(e) => handleStateFilter(e.target.value)}
                value={selectedState}
                className="pe-3 py-1"
                style={{ width: "150px" }}
              >
                <option value="">All States</option>
                {availableStates.map((state, index) => (
                  <Fragment key={index}>
                    <option value={state}>{state}</option>
                  </Fragment>
                ))}
              </select>
            </div>
          </div>
        </div>

        {/* Trips Section with Swiper */}
        <div className="col-lg-12">
          <div className="row d-flex justify-content-center">
            <div className="col-lg-12 px-5 px-lg-5">
              {error ? (
                <div className="text-center py-5">
                  <h4>{error}</h4>
                  <img src={NotFound} alt="No Data" style={{ maxWidth: "400px", width: "100%" }} />
                </div>
              ) : groupedTrips.length > 0 ? (
                groupedTrips.map((elem, index) => {
                  const { location, packages } = elem;
                  return (
                    <div
                      key={index}
                      ref={(el) => (sectionRefs.current[location] = el)}
                      className="my-4 px-0 px-lg-5 px-xl-5 custom-weekend-trips-trip-card-container"
                    >
                      <h3
                        className="pt-3 custom-font-size w-100"
                        style={{
                          color: "#249acd",
                          padding: "0 0 7px",
                          borderBottom: "4px solid #f36d21",
                          textTransform: "capitalize",
                        }}
                      >
                        {location}
                      </h3>

                      <Swiper
                        modules={[Navigation, Pagination]}
                        spaceBetween={20}
                        slidesPerView={1}
                        navigation
                        pagination={{ clickable: true }}
                        breakpoints={{
                          640: { slidesPerView: 2, spaceBetween: 20 },
                          768: { slidesPerView: 2, spaceBetween: 30 },
                          1024: { slidesPerView: 3, spaceBetween: 25 },
                          1440: { slidesPerView: 4, spaceBetween: 35 },
                        }}
                        className="my-3 custom-aligned-swiper custom-all-trips-slider-swiper-cont"
                      >
                        {packages.map((trip) => (
                          <SwiperSlide key={trip?.id || Math.random()}>
                            <TripCard trip={trip} showLocationInCard={false} />
                          </SwiperSlide>
                        ))}
                      </Swiper>
                    </div>
                  );
                })
              ) : (
                <div className="text-center py-5">
                  <img
                    src={NotFound}
                    alt="No Trips Available"
                    style={{ maxWidth: "400px", width: "100%" }}
                  />
                  <h4 className="mt-3">
                    {selectedState
                      ? `No ${activeBtn} available for ${selectedState} at the moment.`
                      : `No ${activeBtn} available at the moment.`}
                  </h4>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WeekendTrips;
